import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import ErrorBoundary from "./components/ErrorBoundary.tsx";
import "./index.css";
import * as Sentry from "@sentry/react";

// Initialize Sentry for production error tracking (only when real DSN is set)
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (import.meta.env.PROD && sentryDsn && !sentryDsn.includes('example')) {
  Sentry.init({
    dsn: sentryDsn,
    environment: "production",
    sendDefaultPii: false,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.05, // Zero-to-Million Optimized
    tracePropagationTargets: ["localhost", /^https:\/\/ykrngluwgvkschbkxpbv\.supabase\.co/],
    // Session Replay
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,
  });
}

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
